<p>inventory-aging-detail works!</p>
